export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categoryLabel: string;
  author: string;
  publishedAt: string;
  readTime: string;
  imageSeq: string;
  tags: string[];
  featured: boolean;
}

export const articleCategories = [
  { key: 'all', label: '全部文章' },
  { key: 'emotional-companion', label: '情感陪伴' },
  { key: 'quality-life', label: '品质生活' },
  { key: 'soul-growth', label: '心灵成长' },
  { key: 'relationship', label: '关系经营' },
];

export const articles: Article[] = [
  {
    id: 'art-001',
    title: '如何在忙碌生活中为伴侣创造高质量陪伴时光',
    summary: '在快节奏的现代生活中，我们常常忽略了最重要的陪伴。本文分享五个实用方法，帮助你在忙碌中依然能为伴侣提供温暖而高质量的陪伴。',
    content: `<p>在这个信息爆炸、节奏飞快的时代，"我很忙"已经成为了许多人的口头禅。然而，再忙碌的生活也不应该成为忽略伴侣的借口。高质量的陪伴不在于时间的长短，而在于投入的程度。</p>
<h2>一、专注当下，放下手机</h2>
<p>当你与伴侣相处时，请放下手机和其他电子设备。研究表明，仅仅是在同一空间各自刷手机，并不是真正的陪伴。试着每天安排至少30分钟的"无屏幕时间"，全身心地投入到与伴侣的交流中。</p>
<h2>二、创造仪式感</h2>
<p>仪式感并不需要隆重的排场。它可以是一起准备一顿简单的晚餐、周末早晨的一杯手冲咖啡、或者睡前十分钟的轻声交谈。这些小小的仪式会让彼此感受到被重视和被爱。</p>
<h2>三、学会深度倾听</h2>
<p>真正的倾听不是等待自己说话的机会，而是全身心地理解对方想要表达的情感。当伴侣分享时，试着用眼神、点头和简短的回应表明你在认真聆听，而不是急于给出建议。</p>
<h2>四、共同创造回忆</h2>
<p>与其被动地度过每一天，不如主动创造属于两个人的美好回忆。可以是一次周末短途旅行、一起学习一项新技能、或者共同完成一个家居项目。共同的经历会加深情感的纽带。</p>
<h2>五、表达感激与欣赏</h2>
<p>不要吝啬你的赞美和感谢。即使是日常生活中最微小的善意，也值得被看见和被感谢。一句"谢谢你今天为我准备的早餐"或者"我真的很欣赏你的耐心"，都能让对方感受到温暖。</p>
<p>陪伴是最长情的告白。久久伊人相信，真正的情感品质来自于每一次用心的陪伴。从今天开始，试着将以上方法融入你的日常生活，让每一段珍贵的关系都能久久延续。</p>`,
    category: 'emotional-companion',
    categoryLabel: '情感陪伴',
    author: '久久伊人编辑部',
    publishedAt: '2026-07-28',
    readTime: '8 分钟',
    imageSeq: 'art-001',
    tags: ['高质量陪伴', '情感关系', '伴侣相处'],
    featured: true,
  },
  {
    id: 'art-002',
    title: '品质生活的五个维度：从物质到精神的全面提升',
    summary: '品质生活不仅仅是物质的丰裕，更是一种生活态度和精神追求。本文从居住、饮食、社交、学习和心灵五个维度，探讨如何构建真正的高品质生活。',
    content: `<p>当我们谈论"品质生活"时，很多人的第一反应是昂贵的物质享受。然而，真正的品质生活是一种全方位的生命体验，它涵盖了物质与精神、外在与内在的多个维度。</p>
<h2>居住维度：打造心灵栖息地</h2>
<p>家不仅是一个物理空间，更是心灵的栖息地。一个高品质的居住环境不需要奢华，但需要舒适、整洁和有序。尝试定期整理空间，引入绿植和自然光线，让家的每一个角落都充满温馨与安宁。</p>
<h2>饮食维度：用心对待每一餐</h2>
<p>品质饮食不在于山珍海味，而在于对食材的尊重和对烹饪的用心。选择新鲜、健康的食材，享受烹饪的过程，将每一餐都变成一次小小的仪式，这是对自己身体的珍视。</p>
<h2>社交维度：建立深度连接</h2>
<p>真正有品质的社交不是泛泛之交的数量，而是能够进行心灵对话的深度关系。减少无效社交，将时间和精力投入到那些能让你感到温暖和被理解的关系中。</p>
<h2>学习维度：保持终身成长</h2>
<p>品质生活离不开持续的学习和成长。无论是阅读一本好书、学习一项新技能、还是探索一个陌生的领域，保持好奇心和学习热情，让生命始终充满活力。</p>
<h2>心灵维度：培养内在平和</h2>
<p>在这个喧嚣的世界中，内心的平静是最奢侈的品质。通过冥想、写作、散步或任何能够让你与自己对话的方式，培养内在的平和与满足感。</p>
<p>久久伊人相信，品质生活是一种可以修炼的能力。它需要我们有意识地选择、投入和坚持。从今天开始，试着在以上五个维度中，找到属于自己的品质提升之路。</p>`,
    category: 'quality-life',
    categoryLabel: '品质生活',
    author: '久久伊人编辑部',
    publishedAt: '2026-07-25',
    readTime: '10 分钟',
    imageSeq: 'art-002',
    tags: ['品质生活', '生活态度', '精神成长'],
    featured: true,
  },
  {
    id: 'art-003',
    title: '独处是一种能力：学会与自己温柔相处',
    summary: '在追求情感陪伴的同时，学会独处同样重要。本文探讨如何培养独处的能力，在独处中找到内心的宁静与力量，让陪伴变得更加珍贵而深刻。',
    content: `<p>我们常常把"独处"与"孤独"混淆。孤独是一种被迫的隔离感，而独处则是一种主动选择的能力——选择与自己温柔相处，选择在安静中聆听内心的声音。</p>
<h2>独处不是逃避，而是回归</h2>
<p>在繁忙的社交和工作之余，独处让我们有机会回归自我。它不是为了逃避世界，而是为了更好地理解自己在世界中的位置。当你学会独处，你会发现与他人相处时也会更加从容和真实。</p>
<h2>培养独处能力的三个方法</h2>
<p><strong>1. 建立独处仪式：</strong>为自己设定固定的独处时间，可以是一杯茶的午后时光、一段安静的晨间阅读，或者一次独自的傍晚散步。让独处成为一种期待而非恐惧。</p>
<p><strong>2. 与内心对话：</strong>尝试写日记或进行自由书写。将思绪和情感倾泻在纸上，不加评判地观察自己的内心世界。这个过程中，你会发现很多被日常生活掩盖的真实感受。</p>
<p><strong>3. 享受独处的乐趣：</strong>找到那些你真正享受的独处活动——也许是烹饪、绘画、园艺、音乐，或者只是静静地看着窗外的风景。这些活动会成为你与自己连接的重要桥梁。</p>
<h2>独处与陪伴的平衡</h2>
<p>有趣的是，越是擅长独处的人，往往越能给予他人高质量的陪伴。因为他们不将陪伴视为填补空虚的手段，而是发自内心地选择与另一个人分享生命的美好。</p>
<p>久久伊人深信，学会独处是学会爱的第一步。只有当我们能够与自己温柔相处，才能以同样的温柔去对待身边的每一个人。</p>`,
    category: 'soul-growth',
    categoryLabel: '心灵成长',
    author: '久久伊人编辑部',
    publishedAt: '2026-07-20',
    readTime: '7 分钟',
    imageSeq: 'art-003',
    tags: ['独处能力', '心灵成长', '自我认知'],
    featured: true,
  },
  {
    id: 'art-004',
    title: '亲密关系中的沟通艺术：让每一次对话都充满温度',
    summary: '沟通是亲密关系的基石。本文分享七种提升沟通质量的方法，帮助你与伴侣建立更加深入、真诚的情感连接，让每一次对话都成为增进感情的机会。',
    content: `<p>沟通是亲密关系中最重要的技能之一，却也是最容易被忽视的。许多关系的裂痕并非源于不可调和的矛盾，而是源于日积月累的沟通不畅。</p>
<h2>非暴力沟通的四步法</h2>
<p>当冲突发生时，尝试使用非暴力沟通的框架：<strong>观察 → 感受 → 需求 → 请求</strong>。不说"你总是这么晚回家"，而是说"这周你有三天晚上十点后才回来（观察），我感到有些孤单和担心（感受），因为我希望我们能有更多相处的时间（需求），下周可以至少有两个晚上八点前回来一起吃晚餐吗？（请求）"</p>
<h2>积极回应的力量</h2>
<p>当伴侣分享好消息或表达想法时，你的回应方式决定了对方未来是否愿意继续分享。试着用积极、热情的态度回应，而不是敷衍了事。一个真诚的"太棒了！跟我详细说说"比一个冷淡的"哦"更能滋养关系。</p>
<h2>学会"软启动"</h2>
<p>当需要讨论敏感话题时，用温和的方式开启对话。避免以指责或批评开头，而是用"我"陈述表达自己的感受和需求。例如："我最近感觉我们之间有点距离，想跟你聊聊，可以吗？"</p>
<h2>创造安全的沟通空间</h2>
<p>伴侣需要感受到说真话是安全的。当对方分享脆弱时，不要急于评判、指责或给出解决方案，而是先表达理解和共情。创造一个"无论说什么都不会被攻击"的安全空间，是深度沟通的前提。</p>
<p>久久伊人相信，好的沟通不是天生的天赋，而是可以学习和练习的技能。每一次用心的对话，都是在为关系存入一笔珍贵的"情感存款"。</p>`,
    category: 'relationship',
    categoryLabel: '关系经营',
    author: '久久伊人编辑部',
    publishedAt: '2026-07-18',
    readTime: '9 分钟',
    imageSeq: 'art-004',
    tags: ['亲密关系', '沟通艺术', '非暴力沟通'],
    featured: false,
  },
  {
    id: 'art-005',
    title: '每天十分钟冥想：在喧嚣中找回内心的宁静',
    summary: '冥想不需要复杂的仪式或大量的时间。本文介绍一种简单易行的十分钟冥想方法，帮助你在繁忙的日常生活中快速找回内心的平静与专注。',
    content: `<p>提到冥想，很多人会想到盘腿打坐、莲花坐姿、甚至深山修行。但实际上，冥想可以非常简单——你不需要任何特殊装备，也不需要专门的场地，只需要十分钟和一份愿意尝试的心。</p>
<h2>为什么是十分钟？</h2>
<p>十分钟是一个恰到好处的时间长度。它足够长，让你能够真正进入放松状态；又足够短，让你没有借口说"我没有时间"。每天抽出十分钟，就像给心灵做一次快速充电。</p>
<h2>简单的十分钟冥想指南</h2>
<p><strong>第1-2分钟：安顿身体。</strong>找一个安静舒适的位置坐下，保持脊柱自然直立但不僵硬。双手放在膝盖上或大腿上，轻轻闭上眼睛。</p>
<p><strong>第3-4分钟：觉察呼吸。</strong>将注意力集中在自然的呼吸上。不需要改变呼吸的节奏，只是观察气息进入和离开身体的感觉。你可以将注意力放在鼻尖、胸腔或腹部的起伏上。</p>
<p><strong>第5-7分钟：观察思绪。</strong>很快你会发现脑海中浮现各种念头——今天的工作、明天的安排、刚才的对话……这完全正常。不需要抗拒或评判这些念头，只是注意到它们的存在，然后温柔地将注意力带回呼吸。</p>
<p><strong>第8-9分钟：身体扫描。</strong>将注意力从头顶缓缓移到脚趾，觉察身体各个部位的感觉。是否有紧张、温暖、麻木或其他感受？只是觉察，不需要改变。</p>
<p><strong>第10分钟：温柔回归。</strong>慢慢将注意力带回周围的环境，感受椅子或地面的支撑，轻轻活动手指和脚趾，然后缓缓睁开眼睛。</p>
<h2>坚持下去的小贴士</h2>
<p>将冥想固定在每天的同一时间（比如早晨起床后或睡前），并设置一个温柔的闹钟提醒。不要追求"完美的冥想体验"，每一次走神后再回来，本身就是冥想练习的核心。</p>
<p>久久伊人认为，内心的宁静是最高品质的生活基础。每天十分钟，给自己一份宁静的礼物。</p>`,
    category: 'soul-growth',
    categoryLabel: '心灵成长',
    author: '久久伊人编辑部',
    publishedAt: '2026-07-15',
    readTime: '6 分钟',
    imageSeq: 'art-005',
    tags: ['冥想', '内心宁静', '心理健康'],
    featured: false,
  },
  {
    id: 'art-006',
    title: '打造温暖家居氛围的十个细节：让家成为真正的心灵港湾',
    summary: '家居环境直接影响我们的情绪和生活品质。本文分享十个简单实用的家居布置细节，帮助你打造一个温暖、舒适、充满情感温度的家。',
    content: `<p>家是我们在外奔波一天后最渴望回归的地方。一个温暖的家居环境，能够安抚疲惫的心灵，为第二天注入新的能量。以下是十个不需要大动干戈就能提升家居温暖感的细节。</p>
<h2>一、灯光的魔力</h2>
<p>避免使用单一的顶灯照明。在客厅和卧室增加落地灯、台灯或壁灯，使用暖色调（2700K-3000K）的灯泡，营造层次丰富、温馨柔和的光环境。灯光的温暖程度，决定了家的温度。</p>
<h2>二、布艺的温度</h2>
<p>柔软的抱枕、蓬松的毯子、温暖的窗帘——布艺是家居中传递温暖最重要的载体。选择羊毛、棉麻、绒面等天然材质，在触感和视觉上都能带来舒适体验。</p>
<h2>三、植物的生命力</h2>
<p>室内植物不仅净化空气，更能为空间注入生机。选择一些容易养护的植物，如龟背竹、琴叶榕或绿萝，它们的存在会让家变得更加鲜活。</p>
<h2>四、香气的记忆</h2>
<p>气味是最能唤起情感记忆的感官。选择你喜欢的香薰蜡烛、精油扩香器或线香，让家拥有属于自己独特的香气印记。木质调、柑橘调或花香调都是不错的选择。</p>
<h2>五、展示珍藏的记忆</h2>
<p>将旅行中收集的纪念品、家人合照、或者有特殊意义的物品展示出来。这些充满故事的物件，让家不再只是居住的空间，而是承载情感的容器。</p>
<h2>六、书籍的陪伴</h2>
<p>在家中布置一个小型的阅读角落——一把舒适的椅子、一盏阅读灯、一个小边几，旁边是整齐的书架。书籍不仅是知识的来源，也是家居中最好的装饰。</p>
<h2>七、墙面的温度</h2>
<p>空白的墙壁让空间显得冷清。选择一些与你产生共鸣的艺术品、照片墙或挂毯来装饰墙面，让空间充满个性和温度。</p>
<h2>八、音乐的流动</h2>
<p>一个蓝牙音箱就可以让音乐在家中流动。无论是早晨的轻快旋律、午后的爵士乐，还是夜晚的古典音乐，音乐能为家注入不同的情绪。</p>
<h2>九、有序的收纳</h2>
<p>杂乱的环境会让人心神不宁。投资一些美观实用的收纳工具，让物品各归其位。整洁不等于冰冷——用藤编筐、木质盒等天然材质的收纳工具，既实用又温暖。</p>
<h2>十、留白的智慧</h2>
<p>温暖不等于堆砌。适当的留白让空间有呼吸感，也让每一件精心挑选的物品得到应有的关注。学会减法，才能让真正重要的东西发光。</p>
<p>久久伊人相信，一个温暖的家，是最好的情感充电站。从今天开始，选择一两个你最喜欢的细节去实践，让家慢慢变成你心中理想的模样。</p>`,
    category: 'quality-life',
    categoryLabel: '品质生活',
    author: '久久伊人编辑部',
    publishedAt: '2026-07-10',
    readTime: '8 分钟',
    imageSeq: 'art-006',
    tags: ['家居氛围', '品质生活', '温暖家居'],
    featured: false,
  },
  {
    id: 'art-007',
    title: '情感的保质期：如何让爱情在岁月中历久弥新',
    summary: '时间是爱情最大的考验，也是最温柔的见证。本文探讨长期关系中保持情感新鲜度的秘密，让你的爱情经得起时间的打磨，在岁月中愈发醇厚。',
    content: `<p>很多人说爱情都有保质期。热恋的激情消退后，剩下的似乎只是习惯和责任。但久久伊人相信，真正的爱情不是不会褪色，而是在褪色之后依然选择彼此，并且找到让色彩重新鲜活的方法。</p>
<h2>理解爱情的不同阶段</h2>
<p>爱情大致会经历三个阶段：热恋期（充满激情和新鲜感）、磨合期（发现差异并学习相处）、稳定期（建立深度连接和共同目标）。每个阶段都有其美好和挑战，理解这一点能帮助我们以更成熟的心态面对关系的变化。</p>
<h2>保持好奇心的艺术</h2>
<p>即使在一起多年，每个人仍在不断变化和成长。保持对伴侣的好奇心——像第一次约会那样询问对方的想法、感受和梦想。你会发现，那个"熟悉"的人身上，总有你不知道的新鲜面。</p>
<h2>共同成长的力量</h2>
<p>最持久的爱情关系往往是那些能够共同成长的关系。一起学习新事物、一起面对挑战、一起规划未来——这些共同的经历会不断为关系注入新的活力。</p>
<h2>定期"关系体检"</h2>
<p>就像身体健康需要定期检查一样，关系健康也需要定期的关注。可以每月找一个安静的时间，聊聊彼此对关系的感受："最近你开心吗？""有什么希望我改进的地方？""我们的关系中最让你珍惜的是什么？"</p>
<h2>细节中的爱意</h2>
<p>爱情的新鲜感往往藏在细节中。一个意外的拥抱、一张手写的便条、一杯对方喜欢的咖啡、一次无目的的散步……这些看似微不足道的小事，恰恰是让爱情历久弥新的秘诀。</p>
<p>久久伊人想说，最好的爱情不是永远像初见时那样，而是在经历了所有之后，依然选择牵起对方的手，并且每一天都比昨天更懂得如何去爱。</p>`,
    category: 'relationship',
    categoryLabel: '关系经营',
    author: '久久伊人编辑部',
    publishedAt: '2026-07-05',
    readTime: '7 分钟',
    imageSeq: 'art-007',
    tags: ['爱情保鲜', '长期关系', '情感经营'],
    featured: false,
  },
  {
    id: 'art-008',
    title: '情绪管理不是压抑：学会与负面情绪共处的智慧',
    summary: '真正的情绪管理不是消灭负面情绪，而是学会与它们共处。本文帮助你重新认识情绪的价值，学习实用的情绪调节方法，让情绪成为生活的助力而非阻力。',
    content: `<p>我们生活在一个过度推崇"正能量"的时代。当感到焦虑、悲伤或愤怒时，很多人第一反应是——"我不应该这样想"、"我必须立刻振作起来"。但情绪管理的真谛，从来就不是压抑或消灭负面情绪。</p>
<h2>所有情绪都有价值</h2>
<p>负面情绪就像身体的疼痛信号——它告诉我们某处需要关注。焦虑提醒我们潜在的风险需要应对；悲伤帮助我们处理和接受失去；愤怒告诉我们的边界被侵犯了。如果一味压抑这些信号，我们失去的是了解自己真实需求的机会。</p>
<h2>识别情绪的ABC模型</h2>
<p>心理学家阿尔伯特·艾利斯提出：激发事件（A）本身不直接导致情绪后果（C），而是我们对事件的信念和解读（B）决定了我们的感受。例如：同事没有回复消息（A），如果你认为"他一定是对我有意见"（B），你会感到焦虑和愤怒（C）；但如果你认为"他可能正在忙"（B），你的情绪就会平和许多。</p>
<h2>实用的情绪调节技巧</h2>
<p><strong>1. 命名情绪：</strong>当你感到不舒服时，准确地说出你在感受什么——"我现在感到焦虑"、"我觉得受伤了"、"我有点烦躁"。命名本身就是一种调节。</p>
<p><strong>2. STOP技术：</strong>Stop（停下来）、Take a breath（深呼吸）、Observe（观察自己的想法和身体感受）、Proceed（带着觉察继续行动）。</p>
<p><strong>3. 身体调节：</strong>情绪与身体密切相关。当情绪强烈时，尝试通过身体来调节——深呼吸、散步、伸展、或者简单地改变姿势。</p>
<p><strong>4. 表达而非发泄：</strong>写下来、画出来、或者找一个信任的人倾诉。表达让情绪有了出口，而发泄往往让情绪升级。</p>
<h2>建立情绪韧性</h2>
<p>情绪韧性的本质不是避免负面情绪，而是相信自己有能力度过。每一次成功地与困难情绪共处的经历，都是在增强你的情绪韧性。</p>
<p>久久伊人相信，真正的情绪成熟不是永远快乐，而是在任何情绪面前都能保持对自己的温柔和理解。</p>`,
    category: 'soul-growth',
    categoryLabel: '心灵成长',
    author: '久久伊人编辑部',
    publishedAt: '2026-06-28',
    readTime: '8 分钟',
    imageSeq: 'art-008',
    tags: ['情绪管理', '心理健康', '自我成长'],
    featured: false,
  },
];

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getArticlesByCategory = (category: string): Article[] => {
  if (category === 'all') return articles;
  return articles.filter((a) => a.category === category);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.filter((a) => a.featured);
};